import React from 'react';
import { BsGeo } from '@react-icons/all-files/bs/BsGeo';

import { EditorPlaceholder } from '../../../components/EditorPlaceholder';
import { useEditor } from '../../../hooks';

export interface AnchorTargetProps {
  targetId?: string;
}

export function AnchorTarget({
  targetId,
}: React.PropsWithChildren<AnchorTargetProps>) {
  const { state: { displayMode } } = useEditor();

  const AnchorContents = displayMode === 'view'
    ? <></>
    : <EditorPlaceholder message={`${targetId}로 앵커 URL 설정시 여기로 스크롤됩니다`} />;

  return (
    <div id={targetId} data-testid={targetId}>
      { targetId != null && targetId !== ''
        ? AnchorContents
        : (
          <EditorPlaceholder icon={<BsGeo />} message="앵커 타켓 id를 입력해주세요" />
        ) }
    </div>
  );
}

